interface ICreateDeveloperProductArguments {
  id: number;
  offerType?: string;
}

export interface IDeveloperProduct {
  id: number;
  offerType: string;
}

export function createDeveloperProduct({
  id,
  offerType = 'builder',
}: ICreateDeveloperProductArguments): IDeveloperProduct {
  return { id, offerType };
}
